function updateURLState(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
}

function updatePagination(searchParams){
    // console.log("updating pagination", searchParams);

    var paginationLinks = document.querySelectorAll('.products-pagination a');
    var existingSearchParams = new URLSearchParams(searchParams);

    for( let link of paginationLinks ){
        var searchParamsArray = {};
        var urlBase = link.getAttribute('href').split('?')[0];
        var url = link.getAttribute('href').split('?')[1];
        var urlParams = new URLSearchParams(url);
       
        for(const entry of urlParams.entries()) {
            searchParamsArray[entry[0]] = entry[1];
        }

        for(const existingEntry of existingSearchParams.entries()){
            searchParamsArray[decodeURIComponent(existingEntry[0])] = decodeURIComponent(existingEntry[1]);
        }

        var newUrlParams = new URLSearchParams(searchParamsArray).toString();
        var newUrl = urlBase + '?' + newUrlParams;

        link.setAttribute('href', newUrl)
    }
}

// Filters & Sorting
class ProductFilters extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.drawerContent = this.querySelector('.facet-filters-content');
    
    this.isDragging = { min: false, max: false };
    
    this.initEventListeners();
    
    if (this.querySelector('.price-range-handle-base')) {
      this.initPriceSlider();
    }
  }

  initEventListeners() {
    this.addEventListener('change', (e) => {
      if (e.target.matches('input[type="checkbox"], input[type="number"]')) {
        this.onFilterChange(e);
      }
    });

    this.addEventListener('keyup', (e) => {
      if (e.key === 'Enter') {
        const item = e.target.closest('.filter-group-display__list-item');
        if (item) item.querySelector('input')?.click();
        
        if (e.target.matches('.price-range-handle-min, .price-range-handle-max')) {
          this.onFilterChange(e);
        }
      }
    });

    this.addEventListener('click', (e) => {
      const target = e.target;
      if (target.closest('.facet-filters-toggle')) {
        e.preventDefault();
        this.drawerContent?.classList.toggle('active');
      } else if (target.closest('.facet-filters-list-close') || target.closest('.facet-filters-form-overlay')) {
        this.drawerContent?.classList.remove('active');
      }
    });
  }

  getSerializedParams() {
    const formData = new FormData(this.form);
    const params = new URLSearchParams(formData);

    const searchTerm = new URLSearchParams(window.location.search).get('q');
    if (searchTerm && !params.has('q')) params.set('q', searchTerm);
    params.delete('page');

    return params.toString();
  }
  
  async onFilterChange(event) {
    const searchParams = this.getSerializedParams();
    const sections = this.getSectionsToRender();

    const priceStyles = this.getPriceHandleStyles();

    try {
      await Promise.all(sections.map(section => 
        this.renderSection(section.id, section.selector, searchParams)
      ));

      this.restorePriceStyles(priceStyles);
      updateURLState(searchParams);
      
      event?.target.closest('details')?.removeAttribute('open');
      this.drawerContent?.classList.remove('active');
    } catch (error) {
      console.error('Filtering failed:', error);
    }
  }

  getSectionsToRender() {
    return [
      {
        id: document.querySelector('.products')?.dataset.id,
        selector: '.products'
      },
      {
        id: document.querySelector('.facet-filters')?.dataset.id,
        selector: '.facet-filters .filter-form'
      },
      {
        id: document.querySelector('.facet-filters')?.dataset.id,
        selector: '.facet-filters-count'
      }
    ];
  }

  async renderSection(sectionId, selector, params) {
    if (!sectionId) return;
    const response = await fetch(`${window.location.pathname}?section_id=${sectionId}&${params}`);
    const text = await response.text();
    const html = new DOMParser().parseFromString(text, 'text/html');
    const oldElement = document.querySelector(selector);
    const newElement = html.querySelector(selector);

    if (oldElement && newElement) {
      oldElement.innerHTML = newElement.innerHTML;
    }
  }

  initPriceSlider() {
    const onStart = (e) => {
      const target = e.target;
      if (target.closest('.filter-group-display__price-range-slider-handle--min')) this.isDragging.min = true;
      if (target.closest('.filter-group-display__price-range-slider-handle--max')) this.isDragging.max = true;
    };

    const onEnd = (e) => {
      if (this.isDragging.min || this.isDragging.max) {
        this.isDragging.min = false;
        this.isDragging.max = false;
        this.onFilterChange(e);
      }
    };

    const onMove = (e) => {
      if (!this.isDragging.min && !this.isDragging.max) return;

      const slider = this.querySelector('.filter-group-display__price-range-slider');
      const rect = slider.getBoundingClientRect();
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      
      let percentage = ((clientX - rect.left) / rect.width) * 100;
      percentage = Math.max(0, Math.min(100, percentage));

      const inputMin = this.querySelector('.filter-group-display__price-range-from input');
      const inputMax = this.querySelector('.filter-group-display__price-range-to input');
      const minVal = parseFloat(inputMin.min || 0);
      const maxVal = parseFloat(inputMax.max || 100);
      const calculatedValue = Math.round(((maxVal - minVal) * percentage) / 100 + minVal);

      if (this.isDragging.min) {
        this.querySelector('.filter-group-display__price-range-slider-handle--min').style.width = `${percentage}%`;
        inputMin.value = calculatedValue;
      } else {
        this.querySelector('.filter-group-display__price-range-slider-handle--max').style.width = `${percentage}%`;
        inputMax.value = calculatedValue;
      }
    };

    this.addEventListener('mousedown', onStart);
    this.addEventListener('touchstart', onStart, { passive: true });
    window.addEventListener('mousemove', onMove);
    window.addEventListener('touchmove', onMove, { passive: false });
    window.addEventListener('mouseup', onEnd);
    window.addEventListener('touchend', onEnd);
  }

  getPriceHandleStyles() {
    return {
      min: this.querySelector('.filter-group-display__price-range-slider-handle--min')?.style.width,
      max: this.querySelector('.filter-group-display__price-range-slider-handle--max')?.style.width
    };
  }

  restorePriceStyles(styles) {
    if (styles.min) this.querySelector('.filter-group-display__price-range-slider-handle--min').style.width = styles.min;
    if (styles.max) this.querySelector('.filter-group-display__price-range-slider-handle--max').style.width = styles.max;
  }
}
customElements.define('facet-filters', ProductFilters);

class SortingDropdown extends HTMLElement{
    constructor(){
        super();

        this.dropdownToggle = this.querySelector('.facet-filters-sorting-default');
        this.sortOptions = this.querySelectorAll('li');

        this.dropdownToggle.addEventListener('click', (e)=> {
            this.onClick();
        })

        document.addEventListener('click', (event) => {
            if (event.target !== this && !this.contains(event.target)) {
                this.close()
            }
        })
        
        for( let option of this.sortOptions ){
            option.addEventListener('click', (e) => {
                this.onOptionClick(option);
            });
        }

        document.addEventListener('keyup', (event) => {
            if(event.key == 'Enter'){
                for( let option of this.sortOptions ){
                    if (event.target == option && option.contains(event.target)) {
                        this.onOptionClick(option);
                    }
                }
            }
        })
    }

    onClick = () => {
        if( this.classList.contains('active') ){
            this.close();
        }
        else{
            this.open();
        }
    }

    open = () => {
        this.classList.add('active');
    }

    close = () => {
        this.classList.remove('active');
    }

    onOptionClick = (option) => {
        var value = option.dataset.value;
        // console.log("changed", value);

        var queryParams = {};
        if(window.location.search.length) {    
          for(var aKeyValue, i = 0, aCouples = window.location.search.substring(1).split('&'); i < aCouples.length; i++) {
            aKeyValue = aCouples[i].split('=');
            if (aKeyValue.length > 1) {
                queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
            }
          }
        }

        queryParams.sort_by = value;

        this.ajaxSorting(queryParams);
    }

    ajaxSorting = (queryParams) => {

        var productsSelector = '.products'
        var productsSection = document.querySelector(productsSelector);
        var productsSectionId = productsSection.dataset.id
        var searchParams = new URLSearchParams(queryParams).toString();
        
        fetch(`${window.location.pathname}?section_id=${productsSectionId}&${searchParams}`)
        .then(response => {
            return response.text()
        })
        .then((text) => {

            for( let option of this.sortOptions ){
              if( option.dataset.value == queryParams.sort_by ){
                this.dropdownToggle.querySelector('span').innerHTML = option.innerHTML
              }
            }

            const html = document.createElement('div');
            html.innerHTML = text;
            const newProductsSection = html.querySelector(productsSelector);
            productsSection.innerHTML = newProductsSection.innerHTML;

            updateURLState(searchParams)
            updatePagination(searchParams);

            this.close();
        });
    }
}
customElements.define('sorting-dropdown', SortingDropdown)

function ajaxPagination(params, productsPagination) {

    var productsSelector = '.products'
    var section = document.querySelector(productsSelector);

    fetch(`${window.location.pathname}?${params}`)
        .then(response => {
            return response.text()
        })
        .then((text) => {

            const html = document.createElement('div');
            html.innerHTML = text;
            const productsSection = html.querySelector(productsSelector);

            if( productsPagination.dataset.paginationChoice == '2' || productsPagination.dataset.paginationChoice == '3' ){
                
                productsSection.querySelectorAll('li').forEach(li => {
                    section.querySelector('ul').append(li);
                })
                
                var infiniteButton = document.querySelector('.products-pagination-infinite');
                infiniteButton.dataset.currentPage = html.querySelector('.products-pagination-infinite').dataset.currentPage;
                infiniteButton.disabled = false;

                if(infiniteButton.dataset.currentPage >= infiniteButton.dataset.totalPages){
                    infiniteButton.classList.add('hide');
                }

                if(productsPagination.dataset.paginationChoice == '3'){
                    infiniteButton.classList.add('inactive');
                }

            }
            else{
                section.innerHTML = productsSection.innerHTML;
                updateURLState(params)

                document.querySelector('.section-products').scrollIntoView({
                    behavior: "instant"
                })
            }
            if (window.jdgm && window.jdgm.customizeBadges) {
                window.jdgm.customizeBadges();
            }
        });
}

class ProductsPagination extends HTMLElement {
    constructor(){
        super();

        if(this.dataset.paginationChoice == '2' || this.dataset.paginationChoice == '3'){
            // Pagination Infinite scroll
            this.paginationInfiniteScroll();
        }
        else{
            // Pagination Numbers
            this.paginationNumbers();
        }
    }

    paginationNumbers = () => {
        var paginationLinks = this.querySelectorAll('.products-pagination a');

        for( let link of paginationLinks ){
            link.addEventListener('click', (e) => {
                e.preventDefault();

                var href = link.getAttribute('href');
                var searchParams = href.replace(window.location.pathname + '?', '');

                if (Shopify.designMode) {
                    var pathToReplace = window.location.href.split('?')[0];
                    var searchParams = href.replace(pathToReplace + '?', '');
                }

                // Ajax Pagination
                ajaxPagination(searchParams, this);
            });
        }
    }

    paginationInfiniteScroll = () => {

        var infiniteButton = this.querySelector('.products-pagination-infinite:not(:disabled)');

        infiniteButton.addEventListener('click', (e) => {
            e.preventDefault();

            var newPage = parseInt(infiniteButton.dataset.currentPage) + 1;
            var searchParams = 'page=' + newPage;
            var getParams = window.location.href.split('?');

            if(getParams != ''){
                searchParams = searchParams + "&" + getParams[1];
            }
        
            // console.log("searchParams", searchParams);
            infiniteButton.disabled = true;
            // Ajax Pagination
            ajaxPagination(searchParams, this);
        })

         window.addEventListener('scroll', function() {

            var productsPagination = document.querySelector('products-pagination');
            var infiniteButton = productsPagination.querySelector('.products-pagination-infinite:not(:disabled)');

            if(infiniteButton){
                if(productsPagination.dataset.paginationChoice == '3' && infiniteButton.dataset.currentPage != '1' && parseInt(infiniteButton.dataset.currentPage) < parseInt(infiniteButton.dataset.totalPages)){
                    var windowHeight = window.innerHeight;
                    var elementOffset = 100;

                    var elementPosition = infiniteButton.getBoundingClientRect();
                    if ((elementPosition.bottom + elementOffset) <= windowHeight) {
                        // console.log("triggered infintie scrk=oll")

                        var newPage = parseInt(infiniteButton.dataset.currentPage) + 1;
                        var searchParams = 'page=' + newPage;
                        var getParams = window.location.href.split('?');
                        if(getParams != ''){
                            searchParams = searchParams + "&" + getParams[1];
                        }
                        // console.log("searchParams", searchParams);

                        infiniteButton.disabled = true;
                        // Ajax Pagination
                        ajaxPagination(searchParams, productsPagination);
                    }
                }
            }
         });
    }

    ajaxPagination = () => {
        
        var paginationLinks = document.querySelectorAll('.products-pagination a');
        var productsSelector = '.products'
        var section = document.querySelector(productsSelector);

        for( let link of paginationLinks ){
            link.addEventListener('click', (e) => {
                e.preventDefault();

                var href = link.getAttribute('href');
                var searchParams = href.replace(window.location.pathname + '?', '');
                
                if (Shopify.designMode) {
                    var pathToReplace = window.location.href.split('?')[0];
                    var searchParams = href.replace(pathToReplace + '?', '');
                }

                fetch(`${window.location.pathname}?${searchParams}`)
                    .then(response => {
                        return response.text()
                    })
                    .then((text) => {
                        const html = document.createElement('div');
                        html.innerHTML = text;
                        const productsSection = html.querySelector(productsSelector);
                        section.innerHTML = productsSection.innerHTML;

                        updateURLState(searchParams)
                        if (window.jdgm && window.jdgm.customizeBadges) {
                            window.jdgm.customizeBadges();
                        }

                        document.querySelector('.section-products').scrollIntoView({
                            behavior: "instant"
                        })
                    });
            })
        }
    }
}

customElements.define( 'products-pagination', ProductsPagination )